// Единая семантика состояний нод/хостов (индастриал: честный статус, не фейк-грин).
export interface HealthStyle {
  label: string;
  dot: string;
  text: string;
  ring: string;
}

export const HEALTH: Record<string, HealthStyle> = {
  up: {
    label: "работает",
    dot: "bg-emerald-400 shadow-[0_0_10px_2px_rgba(52,211,153,.5)]",
    text: "text-emerald-300",
    ring: "ring-emerald-500/20",
  },
  degraded: {
    label: "частично",
    dot: "bg-amber-400 shadow-[0_0_10px_2px_rgba(251,191,36,.4)]",
    text: "text-amber-300",
    ring: "ring-amber-500/20",
  },
  down: {
    label: "не работает",
    dot: "bg-rose-500 shadow-[0_0_10px_2px_rgba(244,63,94,.4)]",
    text: "text-rose-300",
    ring: "ring-rose-500/20",
  },
  undeployed: {
    label: "не развёрнут",
    dot: "bg-zinc-500",
    text: "text-zinc-400",
    ring: "ring-white/10",
  },
  no_agent: {
    label: "нет агента",
    dot: "bg-amber-500/70",
    text: "text-amber-300/80",
    ring: "ring-amber-500/10",
  },
  disabled: {
    label: "выключен",
    dot: "bg-zinc-600",
    text: "text-zinc-500",
    ring: "ring-white/10",
  },
  unknown: { label: "…", dot: "bg-zinc-600", text: "text-zinc-500", ring: "ring-white/10" },
};

export const health = (k: string | undefined): HealthStyle => HEALTH[k ?? "unknown"] ?? HEALTH.unknown;

// Вердикт реконсиляции: ожидаемое (БД) vs фактическое (что реально крутится на ноде).
export const VERDICT: Record<string, HealthStyle & { icon: string }> = {
  ok: {
    label: "соответствует конфигурации", icon: "🟢",
    dot: "bg-emerald-400 shadow-[0_0_10px_2px_rgba(52,211,153,.5)]",
    text: "text-emerald-300", ring: "ring-emerald-500/20",
  },
  drift: {
    label: "расхождение конфигурации", icon: "🟡",
    dot: "bg-amber-400 shadow-[0_0_10px_2px_rgba(251,191,36,.4)]",
    text: "text-amber-300", ring: "ring-amber-500/20",
  },
  orphan: {
    label: "посторонний процесс", icon: "🔴",
    dot: "bg-rose-500 shadow-[0_0_10px_2px_rgba(244,63,94,.4)]",
    text: "text-rose-300", ring: "ring-rose-500/20",
  },
  empty: {
    label: "сервис не развёрнут", icon: "🔴",
    dot: "bg-rose-500 shadow-[0_0_10px_2px_rgba(244,63,94,.4)]",
    text: "text-rose-300", ring: "ring-rose-500/20",
  },
  idle: {
    label: "не задействована", icon: "⚪",
    dot: "bg-zinc-500", text: "text-zinc-400", ring: "ring-white/10",
  },
  offline: {
    label: "нет связи", icon: "⚫",
    dot: "bg-zinc-600", text: "text-zinc-500", ring: "ring-white/10",
  },
  unknown: { label: "—", icon: "⚫", dot: "bg-zinc-600", text: "text-zinc-500", ring: "ring-white/10" },
};

export const verdictStyle = (k: string | undefined) => VERDICT[k ?? "unknown"] ?? VERDICT.unknown;
